import { useContext } from 'react'

import { ScrollSliderContext } from '../../ScrollSlider.context'

export function useScrollSliderContext() {
  return useContext(ScrollSliderContext)
}
